module.exports = __webpack_public_path__ + "assets/img/1@2x.6c9adeaa.png";